module.exports = {
  data() {
    return {
      highlightPointer: -1
    };
  },

  watch: {
    filteredOptions() {
      this.highlightPointer = 0;
    }
  },

  methods: {
    highlightPointerUp() {
      if (this.highlightPointer > 0) {
        this.highlightPointer--;
      }
    },

    highlightPointerDown() {
      if (this.highlightPointer < this.filteredOptions.length - 1) {
        this.highlightPointer++;

        // if( this.maybeAdjustScroll ) {
        //   this.maybeAdjustScroll()
        // }
      }
    }

    // highlightPointerSelect() {
    //   if( this.filteredOptions[ this.highlightPointer ] ) {
    //     this.select( this.filteredOptions[ this.highlightPointer ] );
    //   } else if (this.taggable && this.search.length){
    //     this.select(this.search)
    //   }
    
    //   if( this.clearSearchOnSelect ) {
    //     this.search = "";
    //   }
    // }
  }
};
